export class CoApplicantAddressDTO implements ICoApplicantAddressDTO {
    streetAddress1?: string | undefined;
    streetAddress2?: string | undefined;
    zipCode?: number | undefined;
    city?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    countryCode?: string | undefined;

    constructor(data?: ICoApplicantAddressDTO) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export interface ICoApplicantAddressDTO {
    streetAddress1?: string | undefined;
    streetAddress2?: string | undefined;
    zipCode?: number | undefined;
    city?: string | undefined;
    state?: string | undefined;
    countryCode?: string | undefined;
    county?: string | undefined;
}

